import { Pipe, PipeTransform } from '@angular/core';

import { Player } from '@optical/types';

import { UserInfo } from '../state/auth';

@Pipe({
  name: 'initials',
})
export class InitialsPipe implements PipeTransform {
  transform(value: Player | null | undefined): string;
  transform(value: UserInfo | null | undefined): string;
  transform(value: Player | UserInfo | null | undefined): string {
    if (value === null || typeof value === 'undefined') {
      return '?';
    }

    if ('attributes' in value) {
      return `${value.firstName[0]}${value.lastName[0]}`;
    }

    if (!value?.givenName && !value?.familyName) {
      return '?';
    }

    return [
      ...(value?.givenName ? [value.givenName[0]] : []),
      ...(value?.familyName ? [value.familyName[0]] : []),
    ].join('');
  }
}
